import { useRecoveryAccountContext } from "../../../Contexts/RecoveryAccountContext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import NumberField from "../../../Components/NumberField";
import { CircularProgress } from "@mui/material";
import Button from "../../../Components/Button";

const MaxicareCard = () => {
  const {
    formatCardNumber,
    handleNext,
    cardNumber,
    helperText,
    isLoading,
    navigate,
  } = useRecoveryAccountContext();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center">
      <div className="flex flex-col w-full sm:w-148 sm:bg-white min-h-screen sm:min-h-0 items-start sm:items-center rounded-xl sm:mt-24 ">
        <div className="w-full grid grid-cols-1 divide-y">
          <div className="p-4">
            <KeyboardArrowLeftIcon
              className="absolute cursor-pointer "
              onClick={handleBack}
            />
            <div className="text-center font-semibold text-[#1F2328]">
              Recover account
            </div>
          </div>

          <div className="p-4">
            <div className="text-[#1F2328] text-2xl font-bold">
              Enter your Maxicare card number
            </div>
            <div className="text-[#60656D] mt-2 mb-2">
              You will be asked for your personal information when you continue
            </div>
            <div className="text-[#1F2328] font-bold mt-5">
              Maxicare card number
            </div>
            <div className="mt-1">
              <div className="mt-1">
                <NumberField
                  id="maxicareNumber"
                  type="text"
                  placeholder="1168 0000 0000 0000"
                  adornment={<PaymentOutlinedIcon sx={{ color: "#A3A7AB" }} />}
                  value={cardNumber}
                  onChange={formatCardNumber}
                  error={helperText !== ""}
                  helperText={helperText || ""}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white flex-grow" />
        <div className="flex flex-col sm:items-end items-center w-full px-4 mb-3">
          <Button
            disabled={cardNumber === "" || isLoading}
            className={`w-full h-12 mt-2 ${
              cardNumber === "" || isLoading
                ? `text-[#A3A7AB] bg-[#F6F7F7]`
                : `text-white`
            }`}
            onClick={handleNext}
          >
            {isLoading ? <CircularProgress size={"1rem"} /> : "Continue"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MaxicareCard;
